<ion-app>
  <app-reality-check></app-reality-check>
  <app-announce ></app-announce>
  <app-loading-overlay></app-loading-overlay>

  <ion-router-outlet></ion-router-outlet>
</ion-app>
